var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vab-row",
    { staticClass: "row_box" },
    [
      _c("vab-col", { staticClass: "title_box", attrs: { span: 4 } }, [
        _vm._v(" 依頼先 "),
        _c("i", { staticClass: "red" }, [_vm._v("*")]),
      ]),
      _c(
        "vab-col",
        { staticClass: "word_box", attrs: { span: 20 } },
        [
          _c(
            "div",
            { staticClass: "en_box flex_colum" },
            _vm._l(_vm.list, function (item, index) {
              return _c("en-item", {
                key: index,
                on: {
                  click: function ($event) {
                    return _vm.del(index)
                  },
                },
              })
            }),
            1
          ),
          _vm._t("btn", function () {
            return [
              _c(
                "div",
                { staticClass: "flex_start mt12" },
                [
                  _c("vab-button", {
                    staticClass: "no_margin",
                    attrs: { "btn-list": _vm.btnList },
                  }),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
      _c("notify-add-company", {
        ref: "notifyCompany",
        on: { setData: _vm.setData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }